/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Live result of this test, never a persisted completion record.
 */
export const ServerConnectionTestResultStatus = {
  Ready: "ready",
  AuthorizationRequired: "authorization_required",
  ConfigurationRequired: "configuration_required",
  Failed: "failed",
} as const;
/**
 * Live result of this test, never a persisted completion record.
 */
export type ServerConnectionTestResultStatus = OpenEnum<
  typeof ServerConnectionTestResultStatus
>;

export type ServerConnectionTestResult = {
  /**
   * Stable, credential-free reason suitable for choosing a recovery action.
   */
  code: string;
  /**
   * Safe message for display in the failed setup step.
   */
  message: string;
  /**
   * Live result of this test, never a persisted completion record.
   */
  status: ServerConnectionTestResultStatus;
  /**
   * Tools discovered, present only after every tools/list page succeeds.
   */
  toolCount?: number | undefined;
};

/** @internal */
export const ServerConnectionTestResultStatus$inboundSchema: z.ZodMiniType<
  ServerConnectionTestResultStatus,
  unknown
> = openEnums.inboundSchema(ServerConnectionTestResultStatus);

/** @internal */
export const ServerConnectionTestResult$inboundSchema: z.ZodMiniType<
  ServerConnectionTestResult,
  unknown
> = z.pipe(
  z.object({
    code: z.string(),
    message: z.string(),
    status: ServerConnectionTestResultStatus$inboundSchema,
    tool_count: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tool_count": "toolCount",
    });
  }),
);

export function serverConnectionTestResultFromJSON(
  jsonString: string,
): SafeParseResult<ServerConnectionTestResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServerConnectionTestResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServerConnectionTestResult' from JSON`,
  );
}
